import { mapGetters } from "vuex";
import TableColumnsSettings from "@/components/TableColumnsSettings.vue";
import {
  applyColumnOrder,
  getAppliedColumnIds,
  getTablePreferenceTableKey,
} from "@/services/tableColumns.storage";

export default {
  components: {
    TableColumnsSettings,
  },

  data() {
    return {
      appliedHeadersIds: [],
      tableColumnsId: "",
    };
  },

  computed: {
    ...mapGetters("user", ["tablePreferences", "userProfile"]),

    tableColumnsVariant() {
      return "";
    },

    isTableColumnsReady() {
      if (!this.tableColumnsId) {
        return true;
      }

      return Boolean(this.userProfile);
    },

    columnOptionIds() {
      return (this.tableHeaders || []).map((header) => header.id ?? header.value).join(",");
    },

    tablePreferenceKey() {
      return getTablePreferenceTableKey(this.tableColumnsId, this.tableColumnsVariant);
    },

    visibleTableHeaders() {
      if (!this.isTableColumnsReady) {
        return [];
      }

      return applyColumnOrder(this.tableHeaders || [], this.appliedHeadersIds);
    },
  },

  watch: {
    userProfile() {
      this.syncAppliedHeaders();
    },

    columnOptionIds() {
      this.syncAppliedHeaders();
    },

    tablePreferenceKey() {
      this.syncAppliedHeaders();
    },

    tablePreferences: {
      handler() {
        this.syncAppliedHeaders();
      },
      deep: true,
    },
  },

  created() {
    this.syncAppliedHeaders();
  },

  methods: {
    syncAppliedHeaders() {
      if (!this.tableColumnsId) {
        this.appliedHeadersIds = (this.tableHeaders || []).map(
          (header) => header.id ?? header.value
        );

        return;
      }

      if (!this.isTableColumnsReady) {
        return;
      }

      this.appliedHeadersIds = getAppliedColumnIds(
        this.tableHeaders,
        this.tablePreferences,
        this.tablePreferenceKey
      );
    },

    onColumnsSettingsChange(ids) {
      this.appliedHeadersIds = ids;
    },
  },
};
